import { get } from '@alltrails/core/utils/get';
import { NewsroomItemsResponse } from '@/types/newsroom';

export default async function getNewsroomItems(cursor: string): Promise<NewsroomItemsResponse> {
  return get<NewsroomItemsResponse>(`/api/alltrails/marketing_cms/newsroom?cursor=${cursor}`);
}
